package com.wintermar.inspection.feature.domain.model.template

data class InspectionSectionModel(
    val id: String,
    val pageId: String,
    val order: Int,
    val title: String,
    val questions: List<InspectionTemplateQuestionModel> = listOf(),
    var isExpanded: Boolean = true
)
